import Vue from 'vue'

export default {
  apiPrefix: '/api/v2/sites',
  /**
   * 이벤트의 미디어 레코드(mp4/jpg) 목록을 조회한다.
   *
   * CHEKT-1406 이후 이 응답에서 record별 서명 `url`이 제거되었다(메타데이터만 반환).
   * 재생 URL은 getEventRecordViewUrl(view), 스냅샷 URL은 getEventSnapshots(snapshots)로 별도 발급한다.
   *
   * @param {Object} params
   * @param {number|string} params.siteId   - 사이트 아이디
   * @param {number|string} params.deviceId - 디바이스 아이디
   * @param {number|string} params.eventId  - 이벤트 아이디
   * @returns {Promise} vue-resource 응답 Promise (res.body = record 배열; 각 record는 url 없음)
   */
  getSiteDeviceEventRecords: function ({siteId, deviceId, eventId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/events/${eventId}/records?expand=signedurl`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  /**
   * 특정 이벤트 레코드(mp4)의 서명된 "재생(view)" URL을 발급받는다.
   *
   * 목록(getSiteDeviceEventRecords)에서 url이 제거되어(CHEKT-1406), 재생 시점에 record_id로 발급한다.
   * 백엔드 권한 SITE_EVENT_RECORD_READ, 접근 이력 action=viewed / media_type=event_record.
   *
   * @param {Object} params
   * @param {number|string} params.siteId   - 사이트 아이디
   * @param {number|string} params.eventId  - 이벤트 아이디
   * @param {number|string} params.recordId - 재생할 레코드 record_id
   * @returns {Promise} vue-resource 응답 Promise (res.body = { url: string })
   */
  getEventRecordViewUrl: function ({siteId, eventId, recordId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/events/${eventId}/records/${recordId}/view`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  /**
   * 이벤트의 스냅샷(jpg) 서명 URL 맵을 일괄 발급받는다.
   *
   * 백엔드 권한 SITE_EVENT_RECORD_READ, 무로그(hover에서 호출되므로 접근 이력을 남기지 않음).
   * 응답은 record_id → 서명 URL 맵이다.
   *
   * @param {Object} params
   * @param {number|string} params.siteId  - 사이트 아이디
   * @param {number|string} params.eventId - 이벤트 아이디
   * @returns {Promise} vue-resource 응답 Promise (res.body = { snapshot_urls: { [recordId]: string } })
   */
  getEventSnapshots: function ({siteId, eventId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/events/${eventId}/snapshots`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  /**
   * 특정 이벤트 레코드(mp4)의 서명된 "다운로드(download)" URL을 발급받는다.
   *
   * view와 URL 대상은 같지만 권한과 접근 이력이 다르다:
   *   - 권한: SITE_EVENT_RECORD_DOWNLOAD_ACTION (view의 READ보다 상위, owner/admin)
   *   - 접근 이력: action=downloaded / media_type=event_record
   *
   * @param {Object} params
   * @param {number|string} params.siteId   - 사이트 아이디
   * @param {number|string} params.eventId  - 이벤트 아이디
   * @param {number|string} params.recordId - 다운로드할 레코드 record_id
   * @returns {Promise} vue-resource 응답 Promise (res.body = { url: string })
   */
  getEventRecordDownloadUrl: function ({siteId, eventId, recordId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/events/${eventId}/records/${recordId}/download`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
}
